<div class="language-menu">
  <div class="selected-language" (click)="toggleLanguageMenu()">
    <div class="selected-flag">
      <image-loader-flag-utils [url]="_LocalizationService.ISOABBR" [isFlags]="true" extraClasses="flag-rounded"></image-loader-flag-utils>
    </div>
    <div class="selected-lang-name">
      {{ _LocalizationService.langDatas[_LocalizationService.LANGCODE]?.langNativeNames }}
    </div>
    <div class="right">
      <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (isOpenLangMenu ? 'up' : 'down')"></image-loader-utils>
    </div>
  </div>
  <ng-container *ngFor="let lang of langDatasArry">
    <div class="lang-dropdown-menu" *ngIf="isOpenLangMenu">
      <div class="lang-dropdown-item" (click)="selectionChange(lang.langCode)">
        <div class="flag">
          <image-loader-flag-utils [url]="lang.ISOabbr" [isFlags]="true" extraClasses="flag-rounded"></image-loader-flag-utils>
        </div>
        <div class="lang">
          {{ lang.langNativeNames }}
        </div>
      </div>
    </div>
  </ng-container>
</div>
